import React, { Children, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop, jwt } from "./services/index";
import {
  Login,
  PendingInvoices,
  PaymentSuccess,
  Error404,
} from "./views/index";

function Router() {
  const jwToken = jwt();

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path="/"
          element={jwToken ? <Navigate to="/invoices" /> : <Login />}
        />
        <Route
          path="/invoices"
          element={jwToken ? <PendingInvoices /> : <Navigate to="/" />}
        />
        <Route
          path="/payment-success"
          element={jwToken ? <PaymentSuccess /> : <Navigate to="/" />}
        />
        <Route path="/*" element={<Error404 />} />
      </Routes>
    </>
  );
}

export default Router;
